import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { ADDONS, money } from "@/data/products";
import { useCart } from "@/context/CartContext";

export const ShopCard = ({ v }) => {
  const { add, setOpen } = useCart();
  const [picked, setPicked] = useState([]);
  const extra = picked.reduce((s, a) => s + ADDONS.find((x) => x.id === a).price, 0);
  const total = v.price + extra;

  const toggle = (id) =>
    setPicked((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));

  const onAdd = () => {
    add(v.id, picked);
    toast.success(`${v.name} added to cart`);
    setOpen(true);
  };

  return (
    <motion.article
      data-testid={`shop-card-${v.id}`}
      whileHover={{ y: -5 }}
      transition={{ type: "spring", stiffness: 220, damping: 22 }}
      className="h-full rounded-[1.6rem] bg-[#FFFDF4] border border-[#181203]/10 p-5 flex flex-col shadow-[0_10px_30px_rgba(24,18,3,0.07)]"
    >
      <div className="relative h-44 grid place-items-center overflow-hidden rounded-2xl bg-[#E5A910]">
        <div className="absolute inset-0" style={{ background: "radial-gradient(closest-side, rgba(255,255,255,0.5), rgba(255,255,255,0) 75%)" }} />
        <img src={v.img} alt={`${v.name} juice bottle`} className="absolute inset-0 w-full h-full object-contain p-3 drop-shadow-xl transition-transform duration-500 hover:scale-105" />
      </div>
      <div className="flex items-baseline justify-between gap-3 mt-4">
        <h3 data-testid={`shop-name-${v.id}`} className="font-display text-xl font-extrabold tracking-tight">{v.name}</h3>
        <span data-testid={`shop-price-${v.id}`} className="font-display text-xl font-bold">{money(total)}</span>
      </div>
      <div className="mt-3 grid grid-cols-1 gap-1.5">
        {ADDONS.map((a) => (
          <label key={a.id} data-testid={`addon-${v.id}-${a.id}`} className="flex items-center gap-2.5 text-sm font-medium cursor-pointer select-none">
            <input type="checkbox" checked={picked.includes(a.id)} onChange={() => toggle(a.id)} className="w-4 h-4 accent-[#181203]" />
            {a.label}
            <span className="ml-auto text-xs font-bold text-[#594519]">+{money(a.price)}</span>
          </label>
        ))}
      </div>
      <motion.button
        whileTap={{ scale: 0.95 }}
        data-testid={`add-to-cart-button-${v.id}`}
        onClick={onAdd}
        className="mt-4 inline-flex items-center justify-center gap-2 h-11 rounded-full bg-[#181203] text-[#FFD000] font-bold text-sm hover:bg-black transition-colors"
      >
        <Plus className="w-4 h-4" /> Add to cart
      </motion.button>
    </motion.article>
  );
};
